import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mobile-message-reply"
};
const _hoisted_2 = {
  class: "chat-icon"
};
const _hoisted_3 = {
  class: "chat-item"
};
const _hoisted_4 = ["data-clipboard-text", "innerHTML"];
import { nextTick, onMounted, ref } from "vue";
import { showImagePreview } from "vant";
export default {
  __name: 'ChatReply',
  props: {
    content: {
      type: String,
      default: ''
    },
    orgContent: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: '/images/gpt-icon.png'
    }
  },
  setup(__props) {
    const props = __props;
    const contentRef = ref(null);
    onMounted(() => {
      const imgs = contentRef.value.querySelectorAll('img');
      for (let i = 0; i < imgs.length; i++) {
        if (!imgs[i].src) {
          continue;
        }
        imgs[i].addEventListener('click', e => {
          e.stopPropagation();
          showImagePreview([imgs[i].src]);
        });
      }
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
        src: __props.icon
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "triangle"
      }, null, -1)), _createElementVNode("div", {
        class: "content-box",
        ref_key: "contentRef",
        ref: contentRef
      }, [_createElementVNode("div", {
        "data-clipboard-text": __props.orgContent,
        class: "content content-mobile",
        innerHTML: __props.content
      }, null, 8, _hoisted_4)], 512)])]);
    };
  }
};